// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"4b7f881c","647":"3a89505f"}[chunkId] + ".chunk.js";
};